<template>
  <div class="page home">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">Austin Studio Tour</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="pageData">
      <Components :components="pageData.acf.components" location="above" />
      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'Home',
  components: { Components, HeaderNav, Footer },
  data() {
    return {
      pageData: null,
    }
  },
  async mounted() {
    console.log(this.$route.path.replace('/', ''));
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages?slug=${this.$route.path.replace('/', '')}`);
    let page = await pageDataResponse.json();
    this.pageData = page[0];
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page-title {
  font-family: @fontSecondary;
}

</style>



// WEBPACK FOOTER //
// src/pages/Page.vue